import { render, staticRenderFns } from "./cambioDireccion.vue?vue&type=template&id=1ebab65e&"
import script from "./cambioDireccion.vue?vue&type=script&lang=js&"
export * from "./cambioDireccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports